/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IntegrationEventTooltipsActionsTooltip
 */
export interface IntegrationEventTooltipsActionsTooltip {
    /**
     * 
     */
    type?: IntegrationEventTooltipsActionsTooltipTypeEnum;
    /**
     * 
     */
    message?: string;
}


/**
 * @export
 */
export const IntegrationEventTooltipsActionsTooltipTypeEnum = {
    Info: 'info',
    Error: 'error',
    Confirm: 'confirm',
    Revert: 'revert',
} as const;
export type IntegrationEventTooltipsActionsTooltipTypeEnum = typeof IntegrationEventTooltipsActionsTooltipTypeEnum[keyof typeof IntegrationEventTooltipsActionsTooltipTypeEnum];


/**
 * Check if a given object implements the IntegrationEventTooltipsActionsTooltip interface.
 */
export function instanceOfIntegrationEventTooltipsActionsTooltip(value: object): value is IntegrationEventTooltipsActionsTooltip {
    return true;
}

export function IntegrationEventTooltipsActionsTooltipFromJSON(json: any): IntegrationEventTooltipsActionsTooltip {
    return IntegrationEventTooltipsActionsTooltipFromJSONTyped(json, false);
}

export function IntegrationEventTooltipsActionsTooltipFromJSONTyped(json: any, ignoreDiscriminator: boolean): IntegrationEventTooltipsActionsTooltip {
    if (json == null) {
        return json;
    }
    return {
        
        'type': json['type'] == null ? undefined : json['type'],
        'message': json['message'] == null ? undefined : json['message'],
    };
}

export function IntegrationEventTooltipsActionsTooltipToJSON(json: any): IntegrationEventTooltipsActionsTooltip {
    return IntegrationEventTooltipsActionsTooltipToJSONTyped(json, false);
}

export function IntegrationEventTooltipsActionsTooltipToJSONTyped(value?: IntegrationEventTooltipsActionsTooltip | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'type': value['type'],
        'message': value['message'],
    };
}

